import Header from "@components/Header/Header";
import { Container, MenuItemsContainer } from "./LegalCompliance.styles";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import MenuItem from "@components/MenuItem/MenuItem";
import { openLink } from "@lib/telegram";

export default function LegalCompliance() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  return (
    <Container>
      <Header
        title={t('legalCompliance.header')}
        showBackButton={true}
        onBackClick={() => navigate('/settings')}
      />
      <MenuItemsContainer>
        <MenuItem
          title={t('legalCompliance.menuItems.privacyPolicy')}
          iconType="link"
          onClick={() => openLink(`https://jagad.to/privacypolicy`)}
        />
        <MenuItem
          title={t('legalCompliance.menuItems.termsAndConditions')}
          iconType="link"
          onClick={() => openLink(`https://jagad.to/termscondition`)}
        />
      </MenuItemsContainer>
    </Container>
  )
}
